import React, { useCallback } from 'react'
import TextAreaAutosize from 'components/common/TextareaAutosize'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  textArea: {
    position: 'relative',
    borderRadius: 10,
    minHeight: 100,
    border: '1px solid #7F889B',
    fontSize: '14px !important'
  },
  loaderOverlay: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: 1
  },
  regenerateButton: {
    position: 'absolute',
    zIndex: 1,
    bottom: 14,
    right: 11
  }
}))

const AISuggestedMessage = ({
  text,
  setText,
  isLoading,
  onRegenerateMessage,
  wasAIMessageEdited,
  setWasAIMessageEdited
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const handleTextChanged = useCallback(
    newValue => {
      if (!wasAIMessageEdited) {
        setWasAIMessageEdited(true)
      }

      setText(newValue)
    },
    [setText, setWasAIMessageEdited, wasAIMessageEdited]
  )

  return (
    <>
      {isLoading && <CircularProgress size={15} className={classes.loaderOverlay} />}
      <TextAreaAutosize
        isDisabled={isLoading}
        rowsMax={4}
        placeholder={t('pages.patients.selectedPatient.chat.gi.AIMessagePatient.placeholder')}
        style={{ bright: true }}
        className={classes.textArea}
        keepErrorContainerWhenInactive={false}
        value={text}
        setValue={handleTextChanged}
        id="ai-suggested-message-input"
      />
      {/* Hiding for now to saved expensive tokens on backend
      <ButtonBase onClick={onRegenerateMessage} className={classes.regenerateButton}>
        <RegenerateIcon />
      </ButtonBase> */}
    </>
  )
}

export default AISuggestedMessage
